<script>
    import AdminBar from "../../components/AdminBar.svelte";
    import Foot from "../../components/Foot.svelte";
    import DFGPrizeConfig from "../../components/configuration/DFGPrizeConfig.svelte";
    import FindBar from "../../components/FindBar.svelte";
    import {backofficeServiceHost, userRef} from "../../stores/magic-wallet-store";

    let myUserRef
    let gameId
    let balances

    const searchByUserRefAndGameId = async () => {
        if (myUserRef && myUserRef.length > 0) {
            userRef.set(myUserRef)
            balances = await (await fetch(`${backofficeServiceHost}/dfg-prize/biggestPrize?userRef=${myUserRef}&gameId=${gameId}`)).json()
        }
    }

    userRef.subscribe(value => {
        if (value && value.length > 0) {
            myUserRef = value
        }
    })
    let configurations = []

    const loadConfigs = async () => {
        configurations = await (await fetch(`${backofficeServiceHost}/dfg-prize/configs`)).json()
        console.log({configurations})
    }

    loadConfigs()
</script>
<AdminBar/>
<section class="introduction-section">
    <h1>DFG Prizes</h1>
    <FindBar labelText="Goosicorn UserRef" labelText2="GameId" bind:criteria={myUserRef} bind:criteria2={gameId} searchFunction={searchByUserRefAndGameId}/>
</section>
<main>
    {#each configurations as config}
        <DFGPrizeConfig config={config}/>
    {/each}
</main>
<Foot/>
